import { Select, type SelectProps } from '@mantine/core'
import { CURRENCY_OPTIONS, type CurrencyCode } from '../../lib/currency'

interface Props extends Omit<SelectProps, 'value' | 'onChange' | 'data'> {
  value: CurrencyCode | string
  onChange: (next: CurrencyCode) => void
}

/**
 * Currency picker used in invoice / quote / contract create forms.
 * Defaults to IDR; the supported set is defined in lib/currency.ts.
 */
export function CurrencySelect({ value, onChange, ...rest }: Props) {
  return (
    <Select
      data={CURRENCY_OPTIONS}
      value={value}
      onChange={(v) => v && onChange(v as CurrencyCode)}
      allowDeselect={false}
      searchable={false}
      withCheckIcon={false}
      {...rest}
    />
  )
}
